import Image from "next/image";
import IMAGES from "../../../../../images/importImages";
import { conditions, controllbarIconSize } from "../../../../../helpers";
import { ConditionName } from "../../../../../interfaces";
import { useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";

const SettingsIcon = () => {
    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params } }) => ({ videoElementSizeInfo, params }), shallowEqual);

    return (
        <>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i
                    className={`fa-solid fa-gear pl-cursor-pointer pl-text-white ${
                        conditions(ConditionName.isSpinSettingsIcon) && "pl-animate-spin"
                    } ${
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.otherFontAwesome
                            : controllbarIconSize.miniPlayerFontAwesome
                    }`}
                />
            ) : (
                <Image
                    alt="settings-icon"
                    src={IMAGES.settings}
                    width={
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.other
                            : controllbarIconSize.miniPlayer
                    }
                    height={
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.other
                            : controllbarIconSize.miniPlayer
                    }
                    className={`${conditions(ConditionName.isSpinSettingsIcon) && "pl-animate-spin"}`}
                />
            )}
        </>
    );
};

export default SettingsIcon;
